export const REGEX_CPF = /(\d{3}\.){2}(\d{3})(\-\d{2})/g
export const REGEX_EMAIL = /(\@).*(.com|.net|\.)/g
